import React from 'react';
import ProjectItem from './ProjectItem';

const ProjectsList = ({ projects, hoveredProject, setHoveredProject, onProjectSelect }) => {
  return (
    <div>
      {projects.map(project => (
        <ProjectItem
          key={project.id}
          project={project}
          setHoveredProject={setHoveredProject}
          onProjectSelect={onProjectSelect}
        />
      ))}
    </div>
  );
};

export default ProjectsList;
